import { Headless, withMVC } from '@tcp-base/design-system';
import useTokenExchangeController from './TokenExchanger.controller';
import { TokenExchangerModel, TokenExchangerProps } from './TokenExchanger.model';

export const TokenExchanger = withMVC<TokenExchangerProps, TokenExchangerModel>({
  useController: useTokenExchangeController,
  Viewer: Headless,
});
export default TokenExchanger;
